import { useState, useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { Check, Loader2, X } from 'lucide-react';
import orderController from '@/services/OrderController';
import { cn } from '@/utils/merge';
import useStore from '@/store/store';

export const ReadyButton = ({ order, cb }) => {
	const [status, setStatus] = useState('idle');

	let timeoutRef = useRef();

	const handleClick = async () => {
		if (status !== 'idle') return;

		try {
			setStatus('loading');

			const res = await orderController.createFromDraft(order.id);

			if (!res.success) {
				throw new Error('Errorr');
			}
			setStatus('success');

			timeoutRef.current = setTimeout(() => {
				useStore.getState().removeDraftOrderId(order.id);
				cb?.();
			}, 1_300);
		} catch (err) {
			setStatus('error');

			setTimeout(() => {
				setStatus('idle');
			}, 3_500);
		}
	};

	useEffect(function FUNCTION_NAME() {
		return () => {
			clearTimeout(timeoutRef.current);
			timeoutRef.current = null;
		};
	}, []);

	return (
		<div
			onClick={handleClick}
			className={cn(
				'group',
				'mt-1 flex h-[30px] items-center justify-center rounded-sm border-1 px-2.5 pb-0.5 text-base whitespace-nowrap',
				'cursor-pointer overflow-hidden select-none',
				'duration-150',
				'h-[20px] min-w-[50px]',
				'min-[560px]:h-[26px] min-[560px]:min-w-[60px]',
				'min-[860px]:h-[28px] min-[860px]:min-w-[82px]',
				'min-[1300px]:h-[30px] min-[1600px]:min-w-[92px]',

				// 'hover:!text-[rgb(240,240,240)]',
				// status === 'idle' && '!border-[#0f9b9d]/100 !text-[rgb(240,240,240)] hover:!bg-[#0f9b9d]',
				status === 'idle' &&
					'!border-[#0f9b9d]/100 !text-zinc-600 hover:!bg-[#0f9b9d] hover:!text-[rgb(240,240,240)]',

				status === 'loading' && 'border-[#0f9b9d] bg-[#0f9b9d] !text-white',
				status === 'success' && 'border-green-500 bg-green-500 !text-white',
				status === 'error' && 'border-red-500 bg-red-500 !text-white',
			)}
		>
			<AnimatePresence mode='wait'>
				{status === 'idle' && (
					<motion.span
						key='text'
						initial={{ opacity: 0, y: 6 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: -6 }}
						transition={{ duration: 0.12 }}
						className={cn(
							'group-hover:!text-[rgb(240,240,240)]',
							'text-[0.6rem]',
							'min-[560px]:text-[0.6rem]',
							'min-[860px]:text-[0.8rem]',
							'min-[1300px]:text-[0.9rem]',
						)}
					>
						Ετοιμη
					</motion.span>
				)}

				{status === 'loading' && (
					<motion.div
						key='loader'
						initial={{ opacity: 0, scale: 0.8 }}
						animate={{ opacity: 1, scale: 1 }}
						exit={{ opacity: 0, scale: 0.8 }}
					>
						<Loader2 color='rgb(240,240,240)' className='size-4 animate-spin' />
					</motion.div>
				)}

				{status === 'success' && (
					<motion.div
						key='success'
						initial={{ opacity: 0, scale: 0.5 }}
						animate={{ opacity: 1, scale: 1 }}
						exit={{ opacity: 0, scale: 0.5 }}
						transition={{
							type: 'spring',
							stiffness: 500,
							damping: 25,
						}}
					>
						<Check color='rgb(240,240,240)' className='size-4' />
					</motion.div>
				)}

				{status === 'error' && (
					<motion.div
						key='error'
						initial={{ opacity: 0, scale: 0.5 }}
						animate={{ opacity: 1, scale: 1 }}
						exit={{ opacity: 0, scale: 0.5 }}
						transition={{
							type: 'spring',
							stiffness: 500,
							damping: 25,
						}}
					>
						<X color='white' className='size-4' />
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	);
};
